import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  query: Yup.string()
    .min(4, 'Question must be at least 4 letters long')
    .required('Ask your question'),
});
